import React from 'react';
import { FormProvider } from '../../fgs/context/FormContext';
import { ModalProvider } from '../../fgs/context/ModalContext';
import { RequestProvider } from "../../fgs/context/RequestContext";

export default function ContextWrapper({ children }) {
  return (
    <RequestProvider>
      <FormProvider>
        <ModalProvider>
          {children}
        </ModalProvider>
      </FormProvider>
    </RequestProvider>
  );
}
